import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GuidePagesComponent } from './components/guide-pages/guide-pages.component';
import { HomeComponent } from './components/home/home.component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { LoginComponent } from './components/login/login.component';
import { PaymentComponent } from './components/payment/payment.component';
import { SpecialistChangePasswordComponent } from './components/specialist-change-password/specialist-change-password.component';
import { SpecialistLoginComponent } from './components/specialist-login/specialist-login.component';
import { SpecialistMyRegistrationComponent } from './components/specialist-my-registration/specialist-my-registration.component';
import { SpecialistRegistrationComponent } from './components/specialist-registration/specialist-registration.component';
import { SpecialistVerificationComponent } from './components/specialist-verification/specialist-verification.component';
import { WorkProfileComponent } from './components/work-profile/work-profile.component';
import { URLGuard } from './guards/gurd.guard';
import { SpecialistAccessGuard } from './guards/specialist-access.guard';
import { SpecialistAuthGuard } from './guards/specialist-auth.guard';

const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent,
    children: [
      { path: 'home', component: HomeComponent },
      { path: 'profile', component: WorkProfileComponent, canActivate: [URLGuard] },
      { path: 'payment/callback', component: PaymentComponent },
      { path: 'login/:redirectTo', component: LoginComponent },
      { path: 'about', component: GuidePagesComponent },
      { path: 'general', component: GuidePagesComponent },
      { path: 'specialist-login', component: SpecialistLoginComponent, canActivate: [SpecialistAuthGuard] },
      { path: 'specialist-change-password', component: SpecialistChangePasswordComponent, canActivate: [SpecialistAccessGuard] },
      { path: 'specialist-verification', component: SpecialistVerificationComponent, canActivate: [SpecialistAccessGuard] },
      { path: 'specialist-registration', component: SpecialistRegistrationComponent, canActivate: [SpecialistAccessGuard] },
      { path: 'specialist-my-registration', component: SpecialistMyRegistrationComponent, canActivate: [SpecialistAccessGuard] },
      { path: '**', redirectTo: '/home' }
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule]
})

export class AppRoutingModule { }
